'use strict';

exports.__esModule = true;
exports['default'] = componentWillUnmount;

var _property = require('../others/property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function componentWillUnmount(value) {
  return (0, _property2['default'])('componentWillUnmount', value);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/componentWillUnmount.js
// module id = 582
// module chunks = 1